import API from '../../services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';

import { accountActionTypes } from '../../constants/actionTypes/accountActionTypes';
import { preventerTools } from '../../utils/tools/preventerTools';
import { configs } from '../../constants/configs/configs';

const actions = { setError, startSpinner, stopSpinner };

export const setFailureData = failureData => ({
    type: accountActionTypes.SET_AUTHENTICATION_FAILURE_DATA,
    failureData
});


export const postLoginCredentials = (...args) => async dispatch => {
    const [ url, body ] = args;
    const params = [ url, body, undefined, false, undefined , 'application/x-www-form-urlencoded'];
    const data = await API.postData(params, dispatch, actions);
    const {
        redirectUrl
    } = preventerTools.provideObject(data);
    if(redirectUrl) {
        window.location = configs.endpoints.AUTHENTICATION_SUCCESS_REDIRECT.processReplacements({ redirectUrl });
    } else {
        dispatch(setFailureData(data));
    }
};

export const verifyAccessCode = (...args) => async dispatch => {
    const [ url, body, responseExpected = false ] = args;
    const params = [ url, body, undefined, false, undefined , 'application/x-www-form-urlencoded', responseExpected];
    const data = await API.postData(params, dispatch, actions);


    // Initially the 7th param amid params was false.
    // That was changed by me to take responseExpected from arguments which might be passed during tests as true
    // to have returned response from API.
    // Since we definitely with current implementation won't have response, so "if" condition will never be true

    //TODO: Clarify with verifyAccessCode function author how it is supposed to work and refactor as needed

    if (data) {
        console.log('data', data);
    }
};